import React, { useContext, useState } from 'react'
import DefaultMap from '@/pages/notification/DefaultMap.tsx'
import useQueryGetUserDetail from '@/api/auth/getUser.ts'
import useQueryGetMe from '@/api/auth/getMe.ts'
import useQueryGetAlertFalldetectionDetail from '@/api/notification/getAlertFalldetectionDetail.ts'
import { FalldetectionLiveAlertContext } from '@/pages/notification/falldetection/FalldetectionAlertModal.tsx'
import { useTranslation } from 'react-i18next'

export interface IProps {
    className?: string
}

const FalldetectionAlertDetail: React.FC<IProps> = ({ className }) => {
    useTranslation()
    const { id } = useContext(FalldetectionLiveAlertContext)
    const { data } = useQueryGetAlertFalldetectionDetail(id)
    useQueryGetUserDetail(data?.protectee?.id)
    useQueryGetMe()
    const [isExpandedMap] = useState(true)

    return <div className={`w-full h-full flex flex-col ${className}`}>
        <div className='flex flex-col flex-grow overflow-auto px-2 py-2'>
            <div className='flex flex-col justify-center gap-2 h-full w-full max-w-[calc(100vw-2rem)]'>
                <div
                    className='relative flex flex-col bg-gray1 px-4 py-3 border border-gray2 rounded-lg gap-3 flex-grow transition-all duration-300 hover:shadow-md'>
                    <div className={'flex justify-between items-center mb-1'}>
                        <span className="font-medium text-gray-700 truncate">{data?.alert?.location?.address}</span>
                        <img src="/ic_map_marker.png" alt='Map Marker' className="w-6 h-6"/>
                    </div>
                    {isExpandedMap && data?.alert?.location && (
                        <div className="w-full h-[50vh] md:h-[60vh] flex-grow rounded-lg overflow-hidden">
                            <DefaultMap
                                className='w-full h-full'
                                latitude={data?.alert?.location?.latitude}
                                longitude={data?.alert?.location?.longitude}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>
}

export default FalldetectionAlertDetail
